import React, { memo } from "react"
import PropTypes from "prop-types"
import { Card, CardBody, Col } from "reactstrap"

const ClientInfo = ({ title = '', colSize = 3, store_details = {} }) => {
  const clientFields = [
    {
      key: 'full_name',
      label: 'Full Name',
      icon: 'fa fa-user',
      color: '#556ee6'
    },
    {
      key: 'phone',
      label: 'Phone',
      icon: 'fa fa-phone',
      color: '#34c38f'
    },
    {
      key: 'email',
      label: 'Email',
      icon: 'fa fa-envelope',
      color: '#f1b44c',
      isLink: true,
      linkPrefix: 'mailto:'
    },
    {
      key: 'website',
      label: 'Website',
      icon: 'fa fa-globe',
      color: '#50a5f1',
      isLink: true,
      linkPrefix: 'https://'
    }
  ];

  const infoItemStyle = {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 0',
    borderBottom: '1px solid #e9ecef',
    transition: 'background-color 0.2s ease'
  };

  const iconStyle = {
    width: '36px',
    height: '36px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '12px',
    fontSize: '16px',
    flexShrink: 0
  };

  const labelStyle = {
    fontSize: '13px',
    fontWeight: '500',
    color: '#74788d',
    marginBottom: '2px',
    minWidth: '80px'
  };

  const valueStyle = {
    fontSize: '14px',
    fontWeight: '500',
    color: '#495057',
    wordBreak: 'break-word'
  };

  const linkStyle = {
    color: '#556ee6',
    textDecoration: 'none',
    transition: 'color 0.2s ease'
  };

  return (
    <Col xl={colSize}>
      <Card className="border-0 shadow-sm">
        <CardBody style={{ padding: '20px' }}>
          {title && (
            <div className="mb-4">
              <h4 className="card-title mb-0" style={{ fontSize: '16px', fontWeight: '600', color: '#495057' }}>
                {title}
              </h4>
            </div>
          )}
          <div>
            {(() => {
              const visibleFields = clientFields.filter(field => store_details?.[field.key]);
              return visibleFields.map((field, index) => {
                const value = store_details?.[field.key];
                const displayValue = field.key === 'email' && field.isLink ? value : value;
                const linkUrl = field.isLink
                  ? `${field.linkPrefix || ''}${value}`
                  : null;
                const isLast = index === visibleFields.length - 1;

                return (
                  <div
                    key={field.key}
                    style={{
                      ...infoItemStyle,
                      borderBottom: isLast ? 'none' : infoItemStyle.borderBottom,
                      paddingLeft: '4px',
                      paddingRight: '4px'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#f8f9fa';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                  >
                    <div style={{ ...iconStyle, backgroundColor: `${field.color}15`, color: field.color }}>
                      <i className={field.icon}></i>
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={labelStyle}>{field.label}</div>
                      <div style={valueStyle}>
                        {linkUrl ? (
                          <a
                            href={linkUrl}
                            target={field.key === 'website' ? "_blank" : undefined}
                            rel={field.key === 'website' ? "noopener noreferrer" : undefined}
                            style={linkStyle}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.color = '#4856d6';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.color = '#556ee6';
                            }}
                          >
                            {displayValue}
                            {field.key === 'website' && <i className="fa fa-external-link ms-2" style={{ fontSize: '12px' }}></i>}
                          </a>
                        ) : (
                          displayValue
                        )}
                      </div>
                    </div>
                  </div>
                );
              })
            })()}
          </div>
          {!clientFields.some(field => store_details?.[field.key]) && (
            <div style={{
              textAlign: 'center',
              padding: '40px 20px',
              color: '#adb5bd',
              fontSize: '14px'
            }}>
              <i className="fa fa-info-circle me-2"></i>
              No client information available
            </div>
          )}
        </CardBody>
      </Card>
    </Col>
  );
};

ClientInfo.propTypes = {
  title: PropTypes.string,
  colSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  store_details: PropTypes.object,
}

export default memo(ClientInfo)
